
import {Injectable} from '@angular/core';
import { Buffer } from 'buffer';
import {Md5} from "ts-md5/dist/md5";
import { DateTime } from 'ionic-angular';
import { StorageService } from './storageservice';
import * as JsEncryptModule from 'jsencrypt';

/**
 * Utils类存放和业务无关的公共方法  工具类
 * http://115.159.223.47/view/52  md5加密 以及  base64编码/解码 参考
 * @description
 */
@Injectable()
export class Utils {
  static browser;

  constructor() {
  }

  static isEmpty(value): boolean {
    return value == null || typeof value === 'string' && value.length === 0;
  }

  static isNotEmpty(value): boolean {
    return !Utils.isEmpty(value);
  }
  
  //base64编码
  static base64Encode(value:string){
    return new Buffer(value).toString('base64');
  }
  
  //base64解码
  static base64Decode(value:string) {
    return new Buffer(value,'base64').toString()
  }
  
  //Md5加密
  static md5HashStr(value:string) {
    return Md5.hashStr(value).toString()
  }
  
  /**
   * 格式“是”or“否”
   * @param value
   * @returns {string|string}
   */
  static formatYesOrNo(value: number|string): string {
    return value == 1 ? '是' : (value == '0' ? '否' : null);
  }

  /**
   * 格式 true or false
   * @param value  默认为false
   * @returns {string|string}
   */
  static formatTrueOrFalse(value: number|string): boolean {
    return value == 1 ? true :  false;
  }

  /**
   * 格式  true or false
   * @param value   默认为true
   * @returns {string|string}
   */
  static formatFalseOrTrue(value: number|string): boolean {
    return value == 1 ? false : true;
  }
  
  /**
   * 格式 1 or 0
   * @param value   默认为 0
   * @returns {string|string}
   */
  static formatOneOrZreo(value: boolean): string {
    return value == true ? '1' : '0';
  }
 
  /**
   * 格式  "2017-02-28","2017-02-29"
   * @param 'yyyy-MM-dd'
   * @returns {string|string}
   */
  static dateDiff(sDate1:string, sDate2:string){
	var d1 = new Date(sDate1.substr(0,10)).getTime(); 
	var d2 = new Date(sDate2.substr(0,10)).getTime(); 
	return Math.ceil(Math.abs(d2 - d1) / 1000 / 60 / 60 /24); //把相差的毫秒數轉抽象為天數
  }
  
  /**
   * 数组按照自定义规则排序
   */
  static sortList(array: Array<any>, args: string): Array<any> {
    array.sort((a: any, b: any) => {
      if (a.args < b.args) {
        return -1;
      } else if (a.args > b.args) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
  //日程冒泡排序
  static listSort(arr:any[]){
  	var temp:any;
  	for(var i=0;i<arr.length-1;i++){
        for(var j=0;j<arr.length-1-i;j++){
            if(arr[j].showSTime>arr[j+1].showSTime){
                temp=arr[j];
                arr[j]=arr[j+1];
                arr[j+1]=temp;
            }else if(arr[j].showSTime==arr[j+1].showSTime){
            	if(arr[j].showSTime==arr[j+1].showSTime){
	            	if(arr[j].showETime>arr[j+1].showETime){
		                temp=arr[j];
		                arr[j]=arr[j+1];
		                arr[j+1]=temp;
		            }
            	}
            }
        }
    }
  }
  /**
   *  数组删除  若存在id的话
   */
  static delArray(obj:any[],id:string){
  	var length = obj.length;
  	for(var i=0;i<length;i++){
  		if(id==obj[i].id){
  			obj.splice(i,1);
  			break;
  		}
  	}
  }
   /**
   *  数组删除  若存在id的话
   */
  static rtSelArray(obj:any[],id:string){
  	var length = obj.length;
  	for(var i=0;i<length;i++){
  		if(id==obj[i].id){
  			return obj[i];
  		}
  	}
  }
  
  /**
   * 月份加减
   */
  static addMonth(ymd,adMonth,format){
  	ymd = ymd.replace('T',' ');
    var d=new Date(ymd);
    d.setMonth(d.getMonth()+adMonth);
    return this.dateFormat(d,format)+'';
  }
  
  /***
   * js 对象的深度拷贝 克隆 
   */
  	static deepClone(obj){
		return JSON.parse(JSON.stringify(obj));
	}
	
  /**
   * 日期对象转为日期字符串
   * @param date 需要格式化的日期对象
   * @param sFormat 输出格式,默认为yyyy-MM-dd                         年：y，月：M，日：d，时：h，分：m，秒：s
   * @example  dateFormat(new Date())                                "2017-02-28"
   * @example  dateFormat(new Date(),'yyyy-MM-dd')                   "2017-02-28"
   * @example  dateFormat(new Date(),'yyyy-MM-dd hh:mm:ss')         "2017-02-28 09:24:00"
   * @example  dateFormat(new Date(),'hh:mm')                       "09:24"
   * @example  dateFormat(new Date(),'yyyy-MM-ddThh:mm:ss+08:00')   "2017-02-28T09:24:00+08:00"
   * @returns {string}
   */
 static dateFormat(date: Date, sFormat:string = 'yyyy-MM-dd'): string {
    let time = {
      Year: 0,
      TYear: '0',
      Month: 0,
      TMonth: '0',
      Day: 0,
      TDay: '0',
      Hour: 0,
      THour: '0',
      hour: 0,
      Thour: '0',
      Minute: 0,
      TMinute: '0',
      Second: 0,
      TSecond: '0',
      Millisecond: 0
    };
    time.Year = date.getFullYear();
    time.TYear = String(time.Year).substr(2);
    time.Month = date.getMonth() + 1;
    time.TMonth = time.Month < 10 ? "0" + time.Month : String(time.Month);
    time.Day = date.getDate();
    time.TDay = time.Day < 10 ? "0" + time.Day : String(time.Day);
    time.Hour = date.getHours();
    time.THour = time.Hour < 10 ? "0" + time.Hour : String(time.Hour);
    time.hour = time.Hour < 13 ? time.Hour : time.Hour - 12;
    time.Thour = time.hour < 10 ? "0" + time.hour : String(time.hour);
    time.Minute = date.getMinutes();
    time.TMinute = time.Minute < 10 ? "0" + time.Minute : String(time.Minute);
    time.Second = date.getSeconds();
    time.TSecond = time.Second < 10 ? "0" + time.Second : String(time.Second);
    time.Millisecond = date.getMilliseconds();

    return sFormat.replace(/yyyy/ig, String(time.Year))
      .replace(/yyy/ig, String(time.Year))
      .replace(/yy/ig, time.TYear)
      .replace(/y/ig, time.TYear)
      .replace(/MM/g, time.TMonth)
      .replace(/M/g, String(time.Month))
      .replace(/dd/ig, time.TDay)
      .replace(/d/ig, String(time.Day))
      .replace(/HH/g, time.THour)
      .replace(/H/g, String(time.Hour))
      .replace(/hh/g, time.Thour)
      .replace(/h/g, String(time.hour))
      .replace(/mm/g, time.TMinute)
      .replace(/m/g, String(time.Minute))
      .replace(/ss/ig, time.TSecond)
      .replace(/s/ig, String(time.Second))
      .replace(/fff/ig, String(time.Millisecond))
  }

  /**
   * 每次调用sequence加1
   * @type {()=>number}
   */
  getSequence = (function () {
    let sequence = 100;
    return function () {
      return ++sequence;
    };
  })();


   /**
   * 根据时间参数与当前时间的间隔，显示不同的形式时间间隔
   * timeStamp时间戳(毫秒)
   */
static formateTimeGap(timeStamp:number):string{
  
  let date = new Date();
  let timeGapMinutes:any = (date.getTime() - timeStamp) / (1000 * 60 * 60) ;//小时为单位
  if(timeGapMinutes < 1){
    if(parseInt(timeGapMinutes*60 + "") <= 0){
      return "1分前";
    }
    return parseInt(timeGapMinutes*60 + "") + "分前";
  }else if(timeGapMinutes < 2){
    return  "1小时前";
  }else if(timeGapMinutes < 3){
    return  "2小时前";
  }else if(timeGapMinutes < 4){
    return  "3小时前";
  }else if(timeGapMinutes < 5){
    return  "4小时前";
  }else if(timeGapMinutes < 6){
    return  "5小时前";
  }else if(timeGapMinutes < 7){
    return  "6小时前";
  }else if(timeGapMinutes < 8){
    return  "7小时前";
  }else if(timeGapMinutes < 9){
    return  "8小时前";
  }else if(timeGapMinutes < 10){
    return  "9小时前";
  }else if(timeGapMinutes < 11){
    return  "10小时前";
  }else if(timeGapMinutes < 12){
    return  "11小时前";
  }else if(timeGapMinutes < 13){
    return  "12小时前";
  }else if(timeGapMinutes < 14){
    return  "13小时前";
  }else if(timeGapMinutes < 15){
    return  "14小时前";
  }else if(timeGapMinutes < 16){
    return  "15小时前";
  }else if(timeGapMinutes < 17){
    return  "16小时前";
  }else if(timeGapMinutes < 18){
    return  "17小时前";
  }else if(timeGapMinutes < 19){
    return  "18小时前";
  }else if(timeGapMinutes < 20){
    return  "19小时前";
  }else if(timeGapMinutes < 21){
    return  "20小时前";
  }else if(timeGapMinutes < 22){
    return  "21小时前";
  }else if(timeGapMinutes < 23){
    return  "22小时前";
  }else if(timeGapMinutes < 24){
    return  "23小时前";
  }else if(timeGapMinutes < 24*2){
    return  "1天前";
  }else if(timeGapMinutes < 24*3){
    return  "2天前";
  }else if(timeGapMinutes < 24*4){
    return  "3天前";
  }else if(timeGapMinutes < 24*5){
    return  "4天前";
  }else{
    let dateTmp = new Date(timeStamp);
    let oYear = dateTmp.getFullYear().toString();
    let oMonth:any  = dateTmp.getMonth() + 1;
    oMonth = oMonth>=10? oMonth:'0'+oMonth;
    let oDay  = dateTmp.getDate()>=10? dateTmp.getDate():'0'+dateTmp.getDate();
   return  oYear + '-' + oMonth + '-' + oDay;
  }
}

/**
   * 判断用户是否已经登录
   */
static isLogined( ):boolean{
  let user:any = StorageService.getObj('currentUser');
  if(user==null||user==""||user.userId==null||user.userId=='undefined'||user.userId==''){
    StorageService.remove('currentUser');
    return false;
  }else{
    return true;
  };
}
/**
 *  判断是否为手机号
 * 1--以1为开头；
 * 2--第二位可为3,4,5,6,7,8,9中的任意一位；
 * 3--最后以0-9的9个整数结尾。
 * @param str 手机号
 */
static isPoneAvailable(str:any){
  if(str == undefined || str == null || str ==""){
    return false;
  }
  var myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  if(!myreg.test(str)){
    return false;
  }
  return true;
}
/**
 * 密码强度规则校验
 * @param str 
 */
static checkPassword(str:any){
  if(str == undefined || str == null || str ==""){
    return "0";
  }
  var checkNum=/^([0-9a-zA-Z])\1{4}$/;
  var checkString=/^[0-9]{5}|[a-z]{5}|[A-Z]{5}$/;
  var checkLength = /^[0-9A-Za-z]{6,16}$/;
  var guize = /^\w+$/;
  if((checkNum.test(str) || checkString.test(str)) && guize.test(str) && str.length >=6 && str.length <=16){
    return "1";
  }

  var checkNum1=/^([0-9a-zA-Z])\1{3}$/;
  var checkString1=/^[0-9]{4}|[a-z]{4}|[A-Z]{4}$/;
  if(!(checkNum1.test(str) || !checkString1.test(str)) && guize.test(str)  && str.length >=6 && str.length <=16){
    return "2";
  }
//数字字母特殊符号（$@$!%*?&）
  var checkguize = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,16}$/;
  if(checkguize.test(str)){
    return "3";
  }

  return 0;
}

/**
 * RSA加密
 * @param para 要加密的内容
 */
static getRSAData(para:any){
  let encrypt = new JsEncryptModule.JSEncrypt();
  let tempKey="MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAkdzRDF5Waw7wSKh7kZ+4iFqU94lFzL8/vXOYS5xgrgBxVn0f49jvNogzftmeG8Ed1Ne0NuETf5TyhQATGlkSA7nbXNyVbf7Rc9qmyQ4BvUPzMrQCc8DQIy3PzMPUfQi8bhSAoCgTz3qJGHn/9nJow24/67jmzQEO9JYiSSyWmw22fqTxOOiDyC7vj5zN0b6B5/nhCxaQZwFWzjfkKGo7MrtLMujae3bo3/hrx7QMgxH2JLpA/zAJVbpladVoHzUiDQ6EZLrDEMP/PkID5e3rUcwir5fwYD+qtyesEmwJTZZSSRLRNI9vI14YrpCxTZLIVEqW1Cb1CFWXx2bIUHrRewIDAQAB";
  encrypt.setPrivateKey(tempKey);
  return encrypt.encrypt(para);
}

}



// WEBPACK FOOTER //
// ./src/providers/service/utils.ts